<template>
  <div>
    <!-- Start Page Title -->
    <div v-if="false" class="page-title-area">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <h2>Cart</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- End Page Title -->

    <!-- Start Cart Area -->
    <section class="cart-area ptb-80">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <form v-if="shoppingCart.length !== 0">
              <div class="cart-table table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">Product</th>
                      <th scope="col">Name</th>
                      <th scope="col">Unit Price</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Total</th>
                    </tr>
                  </thead>

                  <transition-group name="list" tag="tbody">
                    <cart-product
                      v-for="product in shoppingCart"
                      :product="product"
                      :key="product.name"
                      @product-selected="handleProductSelected"
                      @remove-from-cart="handleRemoveFromCart"
                      @quantity-minus="handleMinusQuantity"
                      @quantity-plus="handlePlusQuantity"
                    >
                    </cart-product>
                  </transition-group>
                </table>
              </div>

              <div class="cart-buttons">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="continue-shopping-box">
                      <b-button
                        class="btn btn-light"
                        @click="handleContinueShoppingClick"
                      >
                        Continue Shopping</b-button
                      >
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="cart-totals">
                      <h3>Cart Totals</h3>

                      <ul>
                        <li>
                          Subtotal <span>${{ totalAmount.toFixed(1) }}</span>
                        </li>
                        <li>Shipping <span>$10.00</span></li>
                        <li>
                          Total
                          <span
                            ><b>${{ (totalAmount + 10).toFixed(1) }}</b></span
                          >
                        </li>
                      </ul>
                      <b-button
                        class="btn btn-primary"
                        @click="handleGoToCheckoutClick"
                      >
                        Proceed to Checkout
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div v-else>
              <h2>Cart Is Empty!</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Cart Area -->
  </div>
</template>

<script>
import CartProduct from "../common/cartProduct";
export default {
  name: "ViewCart",
  components: {
    CartProduct
  },
  props: {
    shoppingCart: {
      type: Array,
      required: false,
      default: () => []
    },
    totalAmount: {
      type: Number,
      default: 0
    }
  },
  computed: {},
  methods: {
    handleProductSelected(product) {
      this.$emit("product-selected", product);
    },
    handleMinusQuantity(product) {
      this.$emit("quantity-minus", product);
    },
    handlePlusQuantity(product) {
      console.log("plus it2");
      this.$emit("quantity-plus", product);
    },
    handleRemoveFromCart(product) {
      this.$emit("remove-from-cart", product);
    },
    handleContinueShoppingClick() {
      this.$emit("go-to-storefront");
    },
    handleGoToCheckoutClick() {
      this.$emit("go-to-checkout");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/style.scss";
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
